import { BASE_URL } from '@constants/api'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

export interface ListPushNotificationsRequest {
	page?: number
}

export interface PushNotification {
	id: string
	title: string
	description: string
	purchase_url: string
	image_url: string
	created_at: string
}

export interface ListPushNotificationsResponse {
	data: PushNotification[]
	meta: {
		total: number
		perPage: number
		currentPage: number
		lastPage: number
	}
}

export interface AddPushNotificationRequest {
	title: string
	description: string
	purchaseUrl: string
	image: File
}

export const pushNotificationsApi = createApi({
	reducerPath: 'pushNotificationsApi',
	tagTypes: ['PushNotifications'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: setAuthorization,
	}),
	endpoints: (builder) => ({
		list: builder.query<
			ListPushNotificationsResponse,
			ListPushNotificationsRequest
		>({
			query: ({ page = 1 }) => ({
				url: `/push-notification?limit=20&page=${page}`,
				method: 'GET',
			}),
			providesTags: ['PushNotifications'],
		}),

		add: builder.mutation<void, AddPushNotificationRequest>({
			query: (data) => {
				const formData = new FormData()

				formData.append('title', data.title)
				formData.append('description', data.description)
				formData.append('purchaseUrl', data.purchaseUrl)
				formData.append('image', data.image)

				return {
					url: '/push-notification',
					enctype: 'multipart/form-data',
					body: formData,
					method: 'POST',
				}
			},
			invalidatesTags: ['PushNotifications'],
		}),

		delete: builder.mutation<void, { id: string }>({
			query: ({ id }) => ({
				url: `/client/push-notification/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['PushNotifications'],
		}),
	}),
})
